import {Component} from '@angular/core';
import {AchooColumnChartComponent} from '../achoo-column-chart/achoo-column-chart.component';
import {PdfExportService} from '../../services/export-pdf/pdf-export.service';
import {UserService} from '../../services/user.service';

@Component({
  selector: 'achoo-column-chart-placeholder',
  templateUrl: './achoo-column-chart-placeholder.component.html',
  styleUrls: ['./achoo-column-chart-placeholder.component.scss']
})
export class AchooColumnChartPlaceholderComponent extends AchooColumnChartComponent {

  public fakeItemData = [];

  constructor(protected pdfService: PdfExportService,
              protected userService: UserService) {
    super(pdfService, userService);
    this.fakeItemData.push({ name: '1', y: 10, isFaking: true });
    this.fakeItemData.push({ name: '2', y: 60, isFaking: true });
    this.fakeItemData.push({ name: '3', y: 40, isFaking: true });
    this.fakeItemData.push({ name: '4', y: 20, isFaking: true });
    this.fakeItemData.push({ name: '5', y: 10, isFaking: true });
    this.chartData = this.fakeItemData;
    this.isFallbackView = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/achoo-column-chart-placeholder/achoo-column-chart-placeholder.component.ts